<template>
  <q-stepper
    ref="stepper"
    keep-alive
    flat
    v-model="currentStep"
    header-nav
    color="primary"
    animated
  >
    <slot />
  </q-stepper>
</template>

<script>
/**
 * Stepper
 *
 *  [PROPS]
 *  steps: Number
 *  submitText: String
 */

export default {
  name: 'Stepper',
  props: {
    value: {
      type: Number,
    },
  },
  computed: {
    currentStep: {
      set(val) {
        this.$emit('input', val);
      },
      get() {
        return this.value;
      },
    },
  },
  methods: {
    next() {
      this.$refs['stepper'].next();
    },
    previous() {
      this.$refs['stepper'].previous();
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/quasar.variables.scss';

.q-stepper::v-deep {
  background-color: transparent;

  .q-stepper__header--standard-labels .q-stepper__tab:first-child {
    padding-left: 0;
  }

  .q-stepper__header--standard-labels .q-stepper__tab:last-child {
    padding-right: 0;
  }

  .q-stepper__step-inner {
    padding: 0;
  }

  .q-stepper__dot {
    min-width: $space-base;
    width: $space-base;
    height: $space-base;

    & > span {
      display: none;
    }
  }
}
</style>
